import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscussion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.60166 5.63818C4.25225 6.41149 4.08162 7.22642 4.09249 8.04599C4.11287 9.58223 4.76986 11.0672 5.95663 12.2613C6.66014 12.9714 7.49451 13.5363 8.41265 13.9235C8.70008 14.0446 9.29044 14.2323 9.29044 14.2323C9.29044 14.2323 8.52992 14.7101 8.11303 14.8823C7.37784 15.1857 6.5982 15.3408 5.79298 15.3408H5.76471C4.83131 15.3363 3.91173 15.1166 3.0784 14.6992L0.619151 15.1336C0.278482 15.1336 0.00109863 14.8583 0.00109863 14.5188L0.416335 12.0526C-0.184383 10.2412 0.137195 8.66832 1.51105 7.29236C2.05662 6.74346 2.7047 6.30534 3.41907 6.00249C3.80194 5.8397 4.197 5.71821 4.60166 5.63818Z",
			fill: "#878A8F"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.71951 2.7927C7.89602 3.14244 7.14834 3.65267 6.51891 4.29443C4.31148 6.53446 4.43128 9.56639 6.53738 11.6851C7.16607 12.3198 7.91096 12.8241 8.73028 13.1697C9.57051 13.5237 10.4615 13.7045 11.3818 13.7045H11.4141C12.4808 13.6992 13.5318 13.443 14.4841 12.956L17.2947 13.4628C17.6841 13.4628 18.0011 13.1416 18.0011 12.7455L17.5265 9.86835C18.213 7.75497 17.8455 5.91999 16.2754 4.3147C15.6519 3.67432 14.9112 3.16318 14.0948 2.80985C13.2469 2.44182 12.3466 2.25469 11.4156 2.25001H11.3848C10.4695 2.24813 9.5631 2.43267 8.71951 2.7927ZM8.18288 8.79545C8.63475 8.79545 9.00107 8.42914 9.00107 7.97727C9.00107 7.5254 8.63475 7.15909 8.18288 7.15909C7.73101 7.15909 7.3647 7.5254 7.3647 7.97727C7.3647 8.42914 7.73101 8.79545 8.18288 8.79545ZM12.2738 7.97727C12.2738 8.42914 11.9075 8.79545 11.4556 8.79545C11.0037 8.79545 10.6374 8.42914 10.6374 7.97727C10.6374 7.5254 11.0037 7.15909 11.4556 7.15909C11.9075 7.15909 12.2738 7.5254 12.2738 7.97727ZM14.7283 8.79545C15.1802 8.79545 15.5465 8.42914 15.5465 7.97727C15.5465 7.5254 15.1802 7.15909 14.7283 7.15909C14.2765 7.15909 13.9102 7.5254 13.9102 7.97727C13.9102 8.42914 14.2765 8.79545 14.7283 8.79545Z",
			fill: "#878A8F"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(0.00109863)"
		})
	}) })]
});
export default SvgDiscussion;
